import { render, staticRenderFns } from "./StadiaMarkerMap.vue?vue&type=template&id=37c6ef00&"
import script from "./StadiaMarkerMap.vue?vue&type=script&lang=js&"
export * from "./StadiaMarkerMap.vue?vue&type=script&lang=js&"
import style0 from "./StadiaMarkerMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports